import React, { useRef } from 'react';
import Section from './layouts/Section';
import PageLayout from './layouts/PageLayout';
import emailjs from '@emailjs/browser';

function ContactUs() {
  const form = useRef();
  const nameRef = useRef();
  const emailRef = useRef();
  const subjectRef = useRef();
  const messageRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_f4grfuj', 'template_bjg4ob4', form.current, {
        publicKey: 'LyFrQSP0J8xcnoKSH',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );

    // Reset form fields
    nameRef.current.value = '';
    emailRef.current.value = '';
    subjectRef.current.value = '';
    messageRef.current.value = '';
  };

  return (
    <PageLayout title="Cell Station – Contact Us | Expert Cellphone Repair">
      <Section title={'Contact Us'}>
        <section className='section page-content'>
          <div className='container'>
            <div className='comments-form mt-70'>
              <h3 className='text-dark mb-25'>Get In Touch</h3>
              <form ref={form} onSubmit={sendEmail} method='POST'>
                <div className='row'>
                  <div className='form-group mb-30 col-md-4'>
                    <input
                      name='name'
                      className='form-control shadow-none rounded-0 py-4 px-3'
                      type='text'
                      placeholder='Name'
                      required
                      ref={nameRef}
                    />
                  </div>
                  <div className='form-group mb-30 col-md-4'>
                    <input
                      name='email'
                      className='form-control shadow-none rounded-0 py-4 px-3'
                      type='email'
                      placeholder='Email'
                      required
                      ref={emailRef}
                    />
                  </div>
                  <div className='form-group mb-30 col-md-4'>
                    <input
                      className='form-control shadow-none rounded-0 py-4 px-3'
                      placeholder='Subject'
                      name='subject'
                      ref={subjectRef}
                    />
                  </div>
                  <div className='form-group mb-30 col-md-12'>
                    <textarea
                      className='form-control shadow-none rounded-0 p-3'
                      name='comment'
                      required
                      rows='4'
                      ref={messageRef}
                    />
                  </div>
                </div>
                <button className='btn btn-sm btn-primary' type='submit' name='message'>
                  Submit
                </button>
              </form>
            </div>
          </div>
        </section>
      </Section>
    </PageLayout>
  );
}

export default ContactUs;
